import { Card, Paragraph } from '@zillow/constellation-10';

type Props = {
  note: string;
};

const OfflineMarkNote = ({ note }: Props) => (
  <Card tone="soft" elevated={false} outlined={false} className="fs-exclude" css={{ marginBlock: 'xs' }}>
    <Paragraph css={{ textStyle: 'body-sm', fontWeight: 'bold' }}>Note</Paragraph>
    <Paragraph css={{ textStyle: 'body-sm', color: 'text.subtle' }}>
      <em>“{note}”</em>
    </Paragraph>
  </Card>
);

export default OfflineMarkNote;
